export default __webpack_public_path__ + "static/media/electronics.22dbd916.svg";